import { Component } from '@angular/core'
import { OrderConfirmationThankYouMessageComponent } from '@spartacus/order/components'

@Component({
    selector: 'eb-order-confirmation-thank-you-message',
    templateUrl: './eb-order-confirmation-thank-you-message.component.html',
    styleUrls: ['./eb-order-confirmation-thank-you-message.component.scss'],
    standalone: false
})
export class EbOrderConfirmationThankYouMessageComponent extends OrderConfirmationThankYouMessageComponent {
  ngOnInit() {
    super.ngOnInit()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }
}
